/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Describes actual shape of legend badge that represents a series in a legend
 */
export var ActualLegendItemBadgeShape = /*@__PURE__*/ (function (ActualLegendItemBadgeShape) {
    /**
     * Specifies a circle shape in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["CircleShape"] = 0] = "CircleShape";
    /**
     * Specifies a thin line with overlaid marker in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["LineWithMarker"] = 1] = "LineWithMarker";
    /**
     * Specifies a thin line without overlaid marker in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["LineMarkerless"] = 2] = "LineMarkerless";
    /**
     * Specifies a thick horizontal bar shape in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["BarShape"] = 3] = "BarShape";
    /**
     * Specifies a thick vertical column shape in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["ColumnShape"] = 4] = "ColumnShape";
    /**
     * Specifies standard square shape in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["SquareShape"] = 5] = "SquareShape";
    /**
     * Specifies financial square shape in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["SquareFinancial"] = 6] = "SquareFinancial";
    /**
     * Specifies indicator square shape in a legend
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["SquareIndicator"] = 7] = "SquareIndicator";
    /**
     * Specifies marker shape in a legend as long as the series supports markers
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["MarkerShape"] = 8] = "MarkerShape";
    /**
     * Specifies hidden shape without any adjustment to the series title
     */
    ActualLegendItemBadgeShape[ActualLegendItemBadgeShape["HiddenShape"] = 9] = "HiddenShape";
    return ActualLegendItemBadgeShape;
})({});
/**
 * @hidden
 */
export var ActualLegendItemBadgeShape_$type = /*@__PURE__*/ markEnum('ActualLegendItemBadgeShape', 'CircleShape,0|LineWithMarker,1|LineMarkerless,2|BarShape,3|ColumnShape,4|SquareShape,5|SquareFinancial,6|SquareIndicator,7|MarkerShape,8|HiddenShape,9');
